<template>
  <div id="app" class="h-100">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    var thisObj = this;
    setTimeout(() => {
      try {
        // navigator.serviceWorker.addEventListener("message", event => {
        //   let data = event.data;
        //   // if (data.id) {
        //   //     let url;
        //   //     if (data.type == "employees")
        //   //       url = `/app/employee-detail/${data.id}`;
        //   //     else if (data.type == "complaints")
        //   //       url = `/app/complaints-detail/${data.id}`;
        //   //     this.router.navigate([url]);
        //   // }
        //   console.log(data)
        // });
        // messaging.onMessage(payload => {
        //   console.log("Message received. ", payload);
        //   var data = payload.data;
        //   var notification = new Notification("Fortune Homecare", {
        //     icon: "/assets/images/logo/logo.png",
        //     body: data.message || "You have received a notification!!",
        //     requireInteraction: true
        //   });
        //   notification.onclick = () => {
        //     console.log("clicked", data);
        //     notificationHub.$emit("clicked", data);
        //     // if (data.redirect_to) {
        //     //   let path = "/app" + data.redirect_to.split("app")[1];
        //     //   console.log(path,data);
        //     //   //   thisObj.$router.push({path : path});
        //     //   // location.href = data.redirect_to;
        //     // }
        //     if (data.id == 3 || data.id == 7) {
        //       thisObj.$router.push({
        //         path: `/app/${
        //           data.variant == "B" ? "booking-detail" : "audit-detail"
        //         }/${data.booking_id}`
        //       });
        //     }
        //     notification.close();
        //   };
        //   notificationHub.$emit("received", data);
        // });
        this.initNotification();
      } catch (error) {}
    }, 1000);
  },
  methods: {
    initNotification() {
      navigator.serviceWorker
        .register("/assets/firebase-messaging-sw.js")
        .then(registration => {
          window.messaging.useServiceWorker(registration);
        })
        .then(() => {
          return window.messaging.requestPermission();
        })
        .then(() => {
          return window.messaging.getToken();
        })
        .then(token => {
          console.log(token);
          localStorage.setItem("homecare_admin_fcmtoken", token);
          if (localStorage.getItem("homecare_admin_auth")) {
            ajax.put(
              Constants.default.APIURL.UpdateFCMToken,
              {
                firebase_token: token
              },
              res => {},
              err => {}
            );
          }
        })
        .catch(err => {
          console.log("ServiceWorker registration failed: ", err);
        });

      navigator.serviceWorker.addEventListener("message", event => {
        console.log(event.data)
        let data = event.data.data;
        if (data.id) {
          let url;
          if (data.id == 3 || data.id == 7) {
            this.$router.push({
              path: `/app/${
                data.variant == "B" ? "booking-detail" : "audits-detail"
              }/${data.booking_id}`
            });
          }
        }
      });

      this.winRef.nativeWindow.messaging.onMessage(payload => {
        var data = payload.data;
        var notification = new Notification("Fortune Homecare", {
          icon: "/assets/images/logo/logo.png",
          body: data.message || "You have received a notification!!",
          requireInteraction: true
        });
        notification.onclick = () => {
          notificationHub.$emit("clicked", data);
          if (data.id == 3 || data.id == 7) {
            thisObj.$router.push({
              path: `/app/${
                data.variant == "B" ? "booking-detail" : "audits-detail"
              }/${data.booking_id}`
            });
          }
          notification.close();
        };
        // notificationHub.$emit("received", data);
      });
    }
  }
};
</script>

<style lang="scss">
* {
  font-family: SFProText;
}
.gradient-45deg-indigo-purple,
.sidenav li.active {
  background: #04b48d !important;
}

#breadcrumbs-wrapper.breadcrumbs-dark .breadcrumbs-title,
#breadcrumbs-wrapper.breadcrumbs-dark a {
  color: #fff;
}

#breadcrumbs-wrapper .btn {
  background: white !important;
  color: #04b48d !important;
}

#breadcrumbs-wrapper .breadcrumbs .active {
  color: #f5f1f1 !important;
}

.btn {
  background: #04b48d !important;
  color: #ffffff !important;
}

.tabs .indicator {
  max-width: 120px !important;
}
#main #breadcrumbs-wrapper {
  padding-top: 0 !important;
}
.modal-content.datepicker-container {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.jqte .jqte_editor {
  text-align: left !important;
  max-height: 160px !important;
  min-height: 160px !important;
}
.error-message {
  font-size: 0.8rem !important;
}
.brand-sidebar span.logo-text {
  font-size: 22px;
  padding-left: 10px;
}
.brand-sidebar .brand-logo {
  padding: 22px 17px !important;
}
.modal-footer {
  .dx-loader {
    background: lightgreen !important;
    .loader_btn {
      margin-left: 0;
      top: 0;
      position: relative;
    }
  }
}
.card-content {
  .dx-loader {
    .loader_btn {
      margin-left: 0;
      top: 0;
      position: relative;
    }
  }
}
.dropdown-content {
  max-height: 350px !important;
}
.nodata {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: SFProText;

  i {
    font-size: 42px;
    color: #a1aab4;
  }
  div {
    font-size: 16px;
    color: #183247;
    font-weight: 600;
    margin: 16px 0 27px;
  }
}
.bb0 {
  border-bottom: 0 !important;
}
.center {
  text-align: center !important;
}
.image.error {
  text-align: right;
  color: #ef0000 !important;
  font-size: 0.8rem;
  position: relative;
  top: 0.5rem;
  left: 0rem;
  transform: translateY(0%);
}
.services-list {
  position: fixed;
  overflow: hidden;
  transform: translateY(200%);
  opacity: 0;
  transition: 0.3s ease-in-out;
  height: calc(100% - 0px);
  width: calc(100% - 260px);
  top: 0px;
  left: 260px;
  background: white;
  z-index: 99999999;
  border-left: 1px solid #f5f3f3;
  perspective: 1000px;
  .card {
    min-height: 420px;
  }
  a.sub_btn {
    position: absolute;
    right: 30px;
    color: black;
    font-size: 16px;
    font-weight: 500;
    border: 1px solid gainsboro;
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 5px;
  }
  div#close-service-modal {
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    background: rgb(241, 239, 239);
    i {
      position: absolute;
      left: 20px;
      top: 0px;
      font-size: 31px;
      padding: 15px;
    }
  }
  .mtop {
    margin-top: 0px;
    overflow-y: scroll;
    height: calc(100% - 60px);
  }
}
.show-service {
  transform: translateY(0%);
  opacity: 1;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.faq .jqte {
  margin-top: 40px;
  margin-bottom: 10px;
}

.edit .jqte {
  margin-top: 10px;
}

.jqte {
  border: 1px solid #9e9e9e !important;
  box-shadow: none !important;
  margin-top: 40px;
  margin-left: -4px;
  ul {
    list-style: disc !important;
    padding-left: 20px !important;
    text-align: left !important;
  }
  ul li {
    list-style: disc !important;
  }
  .jqte_tool_label {
    height: 25px !important;
  }
  .jqte_editor {
    text-align: left !important;
    max-height: 200px;
    div {
      text-align: left !important;
    }
  }
}

.descs ul {
  list-style: disc !important;
  padding-left: 20px !important;
  text-align: left !important;
}

.descs ul li {
  list-style: disc !important;
}

.modal .modal-content {
  padding-bottom: 0px !important;
}

.swal-button {
  background-color: #efefef !important;
  color: #212121 !important;
}

.issue .select-wrapper {
  position: relative;
  max-width: 140px;
  input {
    // border: 0 !important;
    height: 1.8rem;
    box-shadow: none !important;
    padding: 0;
    margin: 0;
    border-bottom: 0 !important;
  }
}

.classi .select-wrapper {
  max-width: 140px !important;
}

.status-cls .select-wrapper {
  max-width: 140px !important;
}

.pack .select-wrapper {
  position: relative;
  max-width: 120px;
  input {
    // border: 0 !important;
    height: 1.8rem;
    box-shadow: none !important;
    padding: 0;
    margin: 0;
  }
}

.duration .select-wrapper {
  max-width: 60px;
  input {
    padding-left: 10px !important;
  }
  .dropdown-content {
    top: -250px !important;
    max-height: 300px;
  }
}

.pack-ta.error-ta .character-counter {
  bottom: 10px;
  opacity: 0;
}

.pack-ta .character-counter {
  position: absolute;
  transition: 0.3s;
  opacity: 1;
  bottom: -10px;
  right: 15px;
}

.switch label input[type="checkbox"]:checked + .lever {
  background-color: #ffffff !important;
  border: 1px solid gainsboro !important;
}

.switch label .lever {
  height: 16px !important;
  background-color: #ffffff !important;
  border: 1px solid gainsboro !important;
}

.switch label .lever:after {
  background-color: #919eab;
}

input[type="text"]:not(.browser-default):disabled,
input[type="text"]:not(.browser-default)[readonly="readonly"] {
  border-bottom-style: solid !important;
}

#responsive-table.card {
  min-height: -webkit-fill-available;
}

.select-wrapper input.select-dropdown {
  border-bottom-color: #9e9e9e !important;
}

.switch label input[type="checkbox"]:checked + .lever:after {
  background-color: #04b48d;
}

.nice-select {
  border: 0 !important;
  height: 28px;
  padding-top: 0;
  padding-bottom: 0;
  line-height: 2;
  min-width: 120px;
}

.select-cls .caret {
  // display: none !important;
  fill: rgb(192, 181, 181);
}
.btn[disabled] {
  color: #ffffff !important;
}
.tox-tinymce {
  margin-top: 40px !important;
}
strong {
  font-weight: bolder !important;
}
.datepicker-date-display {
  background-color: #04b48d !important;
  background: #04b48d !important;
}
.datepicker-footer {
  .datepicker-cancel {
    color: #182347 !important;
  }
  .datepicker-done {
    color: #04b48d !important;
  }
}
.assignees-list-items {
  .usr-img {
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    img {
      width: 100%;
    }
  }
}
.form-input-div {
  min-height: 150px;
  display: flex;
  align-items: center;
}
.app-filter {
  color: #183247 !important;
}
.card-title {
  font-size: 20px !important;
  font-weight: 600;
}
.input-field {
  .fs-8 {
    font-size: 0.8rem;
  }
  input {
    font-size: 14px;
  }
}
.search-input {
  .sidebar-search {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    padding: 0 0 1rem 0;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .search-area {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    width: -webkit-calc(100% - 0rem);
    width: -moz-calc(100% - 0rem);
    width: calc(100% - 0rem);
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  i {
    font-size: 1.45rem;
    height: 41px;
    margin-right: 0 !important;
    padding: 0.75rem 0.25rem 0.35rem 0.75rem;
    color: #9e9e9e;
    border-radius: 5px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    background-color: #eceff1;
  }
  .app-filter {
    height: 35px;
    margin-bottom: 0;
    padding: 0.2rem;
    color: #9e9e9e;
    border: none;
    border-radius: 5px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    background-color: #eceff1;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    border-bottom: 0 !important;
    box-shadow: none !important;
  }
}
.search-area {
  i.close-icon {
    position: absolute;
    right: 10px;
    cursor: pointer;
    font-size: 18px;
    top: 22px;
    height: inherit;
    padding: 0;
    line-height: 0;
  }
}

.action-btns {
  margin-top: 40px;
  margin-bottom: 30px;
  a {
    color: #4576e5;
    &.delbtn {
      position: relative;
      top: 25px;
    }
    .add-new-btn {
      width: 14px;
      height: 14px;
      background: #4576e5;
      border-radius: 100%;
      display: inline-block;
      margin-right: 5px;
      position: relative;
      top: 3px;
      i {
        font-size: 14px;
        color: #fff;
        position: relative;
        top: -1px;
      }
    }
  }
}

.swal-text {
  padding: 0 60px !important;
  text-align: center;
}
.back-icon {
  cursor: pointer;
}
</style>
